import { Component, OnInit, OnDestroy } from '@angular/core';
import { CourseService } from '@scaffold/services/course.service';
import { Router } from '@angular/router';
import { ItemsService } from '../../services/items.service';
import { environment } from '@env/environment';
import { HttpUtilService } from '@services/http-util.service';
import { EnvironmentService } from '@services/environment.service';
@Component({
    selector: 'scaffold-course-create',
    templateUrl: './course-create.component.html',
    styleUrls: ['./course-create.component.scss'],
    standalone: false
})
export class CourseCreateComponent implements OnInit, OnDestroy {
  view: any;
  //iconOverrides;
  info = { type: 'courses' };
  data = {
    data: {},
  };

  opmPartners = [];
  opmPartnersOptions = [];
  partnerId = '';

  checkErrors() {
    return this.itemsService.disableSave(this.info.type);
  }

  create() {
    console.log(this.view.data);
    this.courseService.createCourse(this.data, this.partnerId).subscribe(r => {
      this.router.navigateByUrl('/courses/' + r.id);
      console.log(r);
    });
  }

  constructor(
    private courseService: CourseService,
    private router: Router,
    private itemsService: ItemsService,
    private httpUtils: HttpUtilService,
    private environmentService: EnvironmentService
  ) {}

  ngOnDestroy() {
    this.itemsService.removeNewData(this.info.type);
    this.courseService.setPartnerId(null);
  }

  ngOnInit() {
    if (this.environmentService.environment.isOPM) {
      this.httpUtils
        .authGet(environment.apiRoot + '/institution/opm-partners')
        .subscribe(opmPartners => {
          this.opmPartners = opmPartners;
          this.opmPartnersOptions = [
            { id: null, name: 'None' },
            ...opmPartners,
          ];
        });
    }

    this.getCourseCreate();
  }

  private getCourseCreate(partnerId = null) {
    let createUrl = `courses/create`;
    if (partnerId != null) {
      createUrl += `?partnerId=${partnerId}`;
    }

    this.courseService.get(createUrl).subscribe(c => {
      console.log(c);
      this.view = c;
      this.data.data = this.itemsService.getData(this.info);
      if (partnerId != null) {
        this.courseService.setPartnerId(partnerId);
      }
    });
  }

  getNewView() {
    this.getCourseCreate(this.partnerId);
  }
}
